export const WIDGET_CONSTANTS = {
  // Icon sizes
  DEFAULT_ICON_SIZE: 60,
  DEFAULT_MOBILE_ICON_SIZE: 40,

  // Breakpoints
  WIDGET_IFRAME_MOBILE_BREAKPOINT: 640,
  ICON_IFRAME_MOBILE_BREAKPOINT: 105,
  RESET_BREAKPOINT: 640,

  // Screen percentages
  MAX_SCREEN_PERCENTAGE: 0.7, // 70% of screen width
  MOBILE_WIDTH_PERCENTAGE: 0.8, // 80% of screen width for mobile
  MIN_MOBILE_WIDTH: 320,

  // Flyout dimensions
  DEFAULT_FLYOUT_WIDTH: 550,
  DEFAULT_FLYOUT_X_OFFSET: 550,

  // Timing delays
  KEYBOARD_EVENT_DELAY: 50,
  FLYOUT_TOGGLE_DELAY: 500,
  MESSAGE_DELAY: 40,
} as const;

export const {
  DEFAULT_ICON_SIZE,
  DEFAULT_MOBILE_ICON_SIZE,
  WIDGET_IFRAME_MOBILE_BREAKPOINT,
  ICON_IFRAME_MOBILE_BREAKPOINT,
  RESET_BREAKPOINT,
  MAX_SCREEN_PERCENTAGE,
  MOBILE_WIDTH_PERCENTAGE,
  MIN_MOBILE_WIDTH,
  DEFAULT_FLYOUT_WIDTH,
  DEFAULT_FLYOUT_X_OFFSET,
  KEYBOARD_EVENT_DELAY,
  FLYOUT_TOGGLE_DELAY,
  MESSAGE_DELAY,
} = WIDGET_CONSTANTS;
